import React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { RitualsList } from './components/RitualsList';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotadminPermission } from 'data/__generated__';

export const Rituals = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.rituals} />
                </HeaderTitle>
                <NavButtons>
                    <Link to={PAGES.messagesSets.url}>
                        <TotemPrimaryButton requiredPermissions={[TotadminPermission.MessagesSetsRead]}>
                            Séries de messages
                        </TotemPrimaryButton>
                    </Link>
                    <Link to={PAGES.ritualCreate.url}>
                        <TotemPrimaryButton requiredPermissions={[TotadminPermission.RitualsManage]}>
                            Créer un rituel
                        </TotemPrimaryButton>
                    </Link>
                </NavButtons>
            </Header>
            <Content>
                <ListContainer>
                    <RitualsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const NavButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
